import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CuentaBeneficiario } from '../../../../../interfaces/cuenta-beneficiario.interface';


@Component({
  selector: 'app-dialog-beneficiarios',
  templateUrl: './dialog-beneficiarios.component.html',
  styleUrls: ['./dialog-beneficiarios.component.sass']
})
export class DialogBeneficiariosComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogBeneficiariosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CuentaBeneficiario
  ){}

  onNoClick(){
    this.dialogRef.close()
  }

}
